import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";

//Redux
// import { useSelector} from "react-redux";
import DataTable from "react-data-table-component";
import SupplierConstants from "../../../common/SupplierConstants";

//Serivce
import ItemService from "../../../services/supplier_appCommonService";
import { SearchField } from "../../../Components/formElements/SearchField";

const MaterialSelectionModal = React.forwardRef((props, ref) => {
  const [disabled, setDisabled] = useState(true);
  const [data, setData] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);
  const [isCardVisible, setCardVisible] = useState(true);
  const [getSelectedData, setSelectedData] = useState([]);

  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");

  const [allData, setAllData] = useState([]);

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  const handleChangeCat = ({ selectedRows }) => {
    // setSelectedData(selectedRows);
    const updatedSelectedRows = selectedRows.map((row) => ({
      ...row,
      accOnOff: true, // default value added
    }));

    setSelectedData(updatedSelectedRows);

    if (selectedRows.length > 0) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  };

  // const loadGetMaterials = async () => {
  //   let obj = {};
  //   await ItemService.getMaterials(obj).then((item) => {
  //     setData(item.data);
  //   });
  // };

  const loadGetMaterials = async () => {
    setLoading(true);
    try {
      const item = await ItemService.getMaterials({});
      setAllData(item?.data || []);
      setData(item?.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleSearchFuncApi = () => {
    const search = getCommonSearchTxt.toLowerCase().trim();

    if (!search) {
      setData(allData); // reset
      return;
    }

    const filtered = allData.filter(
      (row) =>
        row.materialDescription?.toLowerCase().includes(search) ||
        row.materialCode?.toLowerCase().includes(search) ||
        row.spendLevel1?.toLowerCase().includes(search) ||
        row.spendLevel2?.toLowerCase().includes(search) ||
        row.spendLevel3?.toLowerCase().includes(search)
    );

    setData(filtered);
  };
  useEffect(() => {
    handleSearchFuncApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getCommonSearchTxt]);

  useEffect(() => {
    // setData(categorySelectionData)
    loadGetMaterials();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Handle Submit IviteTeamMembers
  const handleSubmit = async () => {
    props.onselectedcatdata(getSelectedData);
    props.onHide();
  };

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);

  useEffect(() => {
    if (!props.show) {
      // Modal closed → reset everything
      setCommonSearchTxt("");
      setData(allData);
      setSelectedData([]);
      setDisabled(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.show]);

  const columns = [
    {
      name: "Material",
      selector: (row) => row?.materialDescription,
      cell: (row) => (
        <div>
          <p className="m-0 p-0  fw-bold text-primary">
            {row?.materialDescription}{" "}
          </p>
          <p className="m-0 p-0 pt-1  ">{row?.materialCode} </p>
        </div>
      ),
      sortable: true,
      width: "200px",
    },

    {
      name: "UOM",
      selector: (row) => row.unit || "--",
      sortable: true,
      width: "100px",
    },
    {
      name: "Material Type",
      selector: (row) => row.materialType || "--",
      sortable: true,
      width: "200px",
    },
    {
      name: "Spend 1",
      selector: (row) => row.spendLevel1 || "--",
      sortable: true,
      width: "200px",
    },
    {
      name: "Spend 2",
      selector: (row) => row.spendLevel2 || "--",
      sortable: true,
      width: "200px",
    },
    {
      name: "Spend 3",
      selector: (row) => row.spendLevel3 || "--",
      sortable: true,
      width: "200px",
    },
  ];

  return (
    // backdrop="static"
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      dialogClassName="modal-90w"
      ref={ref}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Material Selection
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
        <form className="space-y-4">
          <Row>
            <Col xs={12} md={12} lg={12} className="commLeftRightPadding">
              <div className="accordion" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button align-items-center">
                      {/* Arrow */}
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={toggleCardVisibility}
                        ></i>
                      </Col>

                      {/* Icon */}
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">MS</span>
                      </Col>

                      {/* Title */}
                      <Col xs={12} md={6} lg={6}>
                        <span className="headerTitle d-block">
                          Material Selection
                        </span>
                        <span className="subHeaderTitle">
                          View of Material Selection
                        </span>
                      </Col>

                      {/* 🔍 Search (RIGHT SIDE) */}
                      <Col xs={12} md={4} lg={4} className="text-end">
                        <SearchField
                          name="searchKey"
                          value={getCommonSearchTxt}
                          placeholder="Search Material"
                          onChange={(e) => setCommonSearchTxt(e.target.value)}
                          onClick={handleSearchFuncApi}
                        />
                      </Col>
                    </Row>
                  </h2>

                  <div
                    // id="acc"
                    className={`accordion-collapse collapse show ${
                      isCardVisible ? "visible" : ""
                    }`}
                    // aria-labelledby="headingOne"
                    // data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <Row>
                        <Col xs={12} md={12} lg={12}>
                          <DataTable
                            title=""
                            columns={columns}
                            data={data}
                            progressPending={loading}
                            paginationRowsPerPageOptions={
                              SupplierConstants.ROW_PER_PAGE
                            }
                            pagination
                            // paginationServer
                            // paginationTotalRows={totalRows}
                            // onChangeRowsPerPage={handlePerRowsChange}
                            // onChangePage={handlePageChange}
                            selectableRows
                            onSelectedRowsChange={handleChangeCat}
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          <Row className="justify-end">
            <Col xs={6} md={2} lg={2} className="commLeftRightPadding">
              <button
                type="button"
                onClick={() => props.onHide()}
                className="btn btn-danger mt-4 w-full justify-center rounded-md"
              >
                Cancel
              </button>
            </Col>
            <Col xs={6} md={2} lg={2} className="commLeftRightPadding">
              <button
                type="button"
                onClick={handleSubmit}
                className="btn btn-primary mt-4 w-full justify-center rounded-md"
                disabled={disabled}
              >
                Select
              </button>
            </Col>
          </Row>
        </form>
      </Modal.Body>
    </Modal>
  );
});

export default MaterialSelectionModal;
